import { FormFieldSchema } from 'app/shared/models/form';
import { U21FormFieldTypes } from 'app/shared/u21-ui/components';
import { required } from 'app/shared/utils/validation';

export const FILING_NAME: FormFieldSchema<string> = {
  label: 'Filing name',
  name: 'name',
  required: true,
  validate: required('Filing name is required.'),
  type: U21FormFieldTypes.TEXT,
};

export const DESCRIPTION: FormFieldSchema<string> = {
  label: 'Description',
  name: 'description',
  type: U21FormFieldTypes.TEXTAREA,
};

export const FILING_INFO_SCHEMA = [FILING_NAME, DESCRIPTION];
